import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { isEmpty, get } from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import convertString from "helpers/convertString";

const getFieldCSSClasses = (touched, errors, value) => {
  const classes = ["form-control form-control-lg form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid border-danger");
  }

  if (touched && !isEmpty(value) && !errors) {
    classes.push("is-valid border-success");
  }

  return classes.join(" ");
};

export function CustomInput({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  placeholder = "",
  infoText,
  ...props
}) {
  const intl = useIntl();

  return (
    <div className="form-group row">
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label text-alert">
          <FormattedMessage id={label} />
        </label>
      )}
      <div className="col-lg-9 col-xl-6">
        <input
          type={type}
          className={getFieldCSSClasses(
            get(touched, field.name),
            get(errors, field.name),
            field.value
          )}
          placeholder={placeholder ? intl.formatMessage({ id: placeholder }) : ""}
          {...field}
          {...props}
          id={convertString(label)}
        />
        {infoText && <div className="text-muted mt-2 lms-form-info-text">{infoText}</div>}
        {withFeedbackLabel && (
          <FieldFeedbackLabel
            error={get(errors, field.name)}
            touched={get(touched, field.name)}
            label={<FormattedMessage id={label} />}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )}
      </div>
    </div>
  );
}
